<template>
  <div>
    <label :for="name">{{ label }}</label>
    <input
      :id="name"
      :name="name"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
      @change="handleChange"
    />
  </div>
</template>

<script>
export default {
  name: "inputBox",
  props: {
    label: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      required: "Please Enter Your Details",
    },
  },
  methods: {
    handleChange(event) {
      this.$emit("change", event.target.value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// inputBox.vue?42146bec